import { makeStyles } from '@fluentui/react-components';

export const useSpaceTypeSatisfactionChartStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
});
